import { render, staticRenderFns } from "./AdminDeadLinks.vue?vue&type=template&id=47d885d4"
import script from "./AdminDeadLinks.vue?vue&type=script&lang=js"
export * from "./AdminDeadLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports